export default "__VITE_ASSET__DNdUOE0v__"